import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { concat, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

//Services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { AccountService } from '../../account/services/account.service';
import { EmployeeService } from '../services/employee.service';

@Component({
  selector: 'app-clock-in-out-unlocked',
  templateUrl: './clock-in-out-unlocked.component.html',
  styleUrls: ['./clock-in-out-unlocked.component.css']
})
export class ClockInOutUnlockedComponent implements OnInit, OnDestroy {
  @ViewChild('signaturePad', { static: false }) signaturePad;
  dateFormat: string;
  clockStatus: boolean = null;
  formData: any = {};
  customMsg: string;
  portalSettings: any;
  changePhaseNow: boolean = false;
  employeeResults: any = {};
  requirePasswordClockIO: boolean = false;
  tCClockIOIgnoreJobPhase: boolean = false;
  geolocationEnabled: boolean = false;
  requestingLocation: boolean = false;
  position: any = null;
  performingClockAction: boolean = false;
  clockInUsePhase: boolean = false;
  companyLoginChoices: boolean = false;
  lastUsedJCJPKeyID: any = null;
  lastUsedJCJMKeyID: any = null;
  jobs: any[] = [];
  phases: any[] = [];
  lastFullClockIn: any = null;
  lastFullClockOut: any = null;
  lastClockIn: any = null;
  totalHours: number = null;
  alert: any = null;
  loadingAccess: boolean = false;
  accessToken: any;
  loading: boolean = false;
  employeeName: string;
  requireSign: boolean = false;
  redBorder: boolean = false;
  lastAction: boolean = false;
  pageUnlocked: boolean = false;
  companies: any[] = [];
  signatureData: any;
  signatureNEmpty: boolean = false;
  job$: Observable<any>;
  jobInput$ = new Subject<any>();
  panelWidth: number;
  timeFormat: string = " hh:mm a";

  constructor(portalSettingsService: PortalSettingsService, private utilityService: UtilityService, private employeeService: EmployeeService, private accountService: AccountService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    window.history.pushState(null, null, "/employee/clockinoutunlocked");
    this.dateFormat = this.utilityService.getDateFormat();
    var width = window.innerWidth - 80;
    this.panelWidth = (width > 300 ? 300 : width) + 40;
    this.clockInUsePhase = this.portalSettings.ClockInUsePhase.ConfigValue == "1";
    this.companyLoginChoices = this.portalSettings.CompanyLoginChoices.ConfigValue == "1";
    this.customMsg = this.portalSettings.CustomVerbiageClockOutSign.ConfigValue;
    this.requirePasswordClockIO = this.portalSettings.RequirePasswordClockIO.ConfigValue == "1";
    this.tCClockIOIgnoreJobPhase = this.portalSettings.TCClockIOIgnoreJobPhase.ConfigValue == "1";
    this.requireSign = this.portalSettings.RequireSignClockOut.ConfigValue == "1";
    this.formData.labelFade = false;
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    if (sessionStorage) {
      this.getLocation();
    }
    if (this.companyLoginChoices) {
      this.getCompanies();
    }
    this.registerLookups();
  }

  ngOnDestroy() {
    this.jobInput$.unsubscribe();
  }

  lockPage() {
    window.location.href = "/Account/Logout";
  }

  getClockInStatus() {
    this.lastFullClockIn = null;
    this.lastFullClockOut = null;
    this.lastClockIn = null;
    this.totalHours = null;
    this.alert = null;
    this.phases = [];
    var currentTime = moment();
    var currentTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
    var requestParam = "pRCo=" + this.formData.PRCo + "&employee=" + this.formData.Employee + " &fromFieldKiosk=true&currentTimeString=" + currentTimeString + "&kioskPass=" + encodeURIComponent(this.formData.unlockPass) ?? null;
    if (!this.requirePasswordClockIO) {
      this.employeeService.getClockInStatus(requestParam).then((response: any) => {
        if (response != null) {
          this.setClockStatusResponse(response);
        }
      });
    }
    else {
      if (this.formData.Employee == null || this.formData.Password == null) {
        this.alert = { type: "danger", msg: "Please enter your Employee # and Password." }
      }
      else {
        this.formData.PMMode = false;
        this.loadingAccess = true;
        this.accountService.login(this.formData).then((response: any) => {
          if (response != null) {
            if (!response.success) {
              // if not successful, bind errors to error variables
              this.alert = { type: "danger", msg: response.errorMessage };
              this.loadingAccess = false;
            }
            else {
              this.accountService.getJobsAccessToken().then((tokenResponse: any) => {
                if (tokenResponse != null) {
                  this.accessToken = tokenResponse[0];
                  this.accountService.getAccountLogoutRedirect().then((response: any) => {
                    var requestParam = "pRCo=" + this.formData.PRCo + "&employee=" + this.formData.Employee + "&fromFieldKiosk=true&currentTimeString=" + currentTimeString + "&jobAccessToken=" + this.accessToken + "&kioskPass=" + encodeURIComponent(this.formData.unlockPass) ?? null;
                    this.employeeService.getClockInStatus(requestParam).then((statusResponse: any) => {
                      if (statusResponse != null) {
                        this.loadingAccess = false;
                        this.setClockStatusResponse(statusResponse);
                      }
                    });
                  });
                }
              });
            }
          }
        }, () => {
          this.alert = { type: "danger", msg: "Error occurred while trying to login, contact your administrator." };
        });
      }
    }
  }

  cancelClockIO() {
    this.alert = null;
    this.accountService.getAccountLogoutRedirect().then((response: any) => {
      this.resetForm();
    });
  }

  changePhase() {
    this.alert = null;
    this.changePhaseNow = true;
  }

  cancelChangePhase() {
    this.changePhaseNow = false;
  }

  confirmChangePhase(ignoreLocation: boolean) {
    if (this.requireSign) {
      this.checkSigned();
    }
    if (!this.redBorder) {
      this.performingClockAction = true;
      var requestObj = { clockInTime: new Date().toISOString(), pRCo: this.formData.PRCo, employee: this.formData.Employee, fromGroupClock: false, gPSLat: null, gPSLong: null, clockTimeString: null, kioskPass: null, jCJMKeyID: null, jCJPKeyID: null };
      if (!ignoreLocation) {
        requestObj.gPSLat = this.position.coords.latitude;
        requestObj.gPSLong = this.position.coords.longitude;
      }
      var currentTime = moment();
      requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
      requestObj.kioskPass = this.formData.unlockPass ?? null;
      this.employeeService.postClockActionAnon(requestObj).then((response: any) => {
        if (response != null) {
          this.requestingLocation = false;
          this.formData.action = null;
          this.formData.actionMode = null;
          if (response.success) {
            if (this.clockInUsePhase) {
              requestObj.jCJMKeyID = this.formData.selectedJob.JCJMKeyID;
              requestObj.jCJPKeyID = this.formData.selectedPhase.JCJPKeyID;
            }
            this.employeeService.postClockActionAnon(requestObj).then((clockResponse: any) => {
              if (clockResponse != null) {
                this.showBanner(clockResponse.resultClockAction);
                this.cancelChangePhase();
              }
            });
            this.alert = null;
          }
          else {
            this.alert = { type: "danger", msg: response.error };
            this.performingClockAction = false;
            this.cancelChangePhase();
            this.resetForm();
          }
        }
      });
    }
  }

  resetGetStatus() {
    this.clockStatus = null;
  }

  postClockAction(ignoreLocation: boolean) {
    this.performingClockAction = true;
    var requestObj = { clockInTime: new Date().toISOString(), pRCo: this.formData.PRCo, employee: this.formData.Employee, gPSLat: null, gPSLong: null, jCJMKeyID: null, jCJPKeyID: null, clockTimeString: null, kioskPass: null };
    if (!ignoreLocation) {
      requestObj.gPSLat = this.position.coords.latitude;
      requestObj.gPSLong = this.position.coords.longitude;
    }
    if (this.clockInUsePhase && !this.clockStatus && this.formData.selectedJob != null && this.formData.selectedPhase != null) {
      requestObj.jCJMKeyID = this.formData.selectedJob.JCJMKeyID;
      requestObj.jCJPKeyID = this.formData.selectedPhase.JCJPKeyID;
    }
    var currentTime = moment();
    requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
    requestObj.kioskPass = this.formData.unlockPass;
    this.employeeService.postClockActionAnon(requestObj).then((response: any) => {
      if (response != null) {
        this.requestingLocation = false;
        this.formData.action = null;
        this.formData.actionMode = null;
        if (response.success) {
          this.showBanner(response.resultClockAction);
        }
        else {
          this.alert = { type: "danger", msg: response.error };
          this.performingClockAction = false;
        }
      }
    });
  }

  unlockForm() {
    this.employeeService.unlockClockInPage(this.formData.unlockPass).then((response: any) => {
      if (response != null) {
        if (response.success) {
          this.alert = null;
          this.pageUnlocked = true;
        }
        else {
          this.alert = { type: "danger", msg: "The unlock password was incorrect." };
        }
      }
    });
  }

  jobChanged() {
    this.formData.selectedPhase = null;
    this.phases = [];
    if (this.formData.selectedJob != null) {
      this.getPhases();
    }
  }

  loadPhase() {
    if ((this.phases == null || this.phases.length <= 0) && this.formData.selectedJob != null && this.formData.selectedJob.JCJMKeyID != null) {
      this.getPhases();
    }
  }

  closeAlert() {
    this.alert = null;
  }

  clockOutClicked(location: any) {
    if (this.requireSign) {
      this.checkSigned();
      if (this.signatureNEmpty) {
        this.signatureData = (this.signaturePad.toDataURL());
        this.postClockAction(location);
      }
    }
  }

  clear() {
    if (this.signaturePad != null) {
      this.signaturePad.clear();
      this.signatureNEmpty = false;
    }
  }

  searchPhases(term: string, item: any) {
    term = term.trim().toLowerCase();
    return item.JCJPKeyID?.toString().indexOf(term) > -1 || item.PhaseDescription?.toLowerCase().indexOf(term) > -1 || item.PhaseGroup?.toString().indexOf(term) > -1;
  }

  private registerLookups() {
    this.job$ = concat(
      this.jobInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(async (term: any) => {
          if (term != null && term.length > 2) {
            var result: any = await this.employeeService.getJobsForClockIn(this.formData.PRCo, this.formData.Employee, term, this.accessToken, encodeURIComponent(this.formData.unlockPass) ?? null);
            result.forEach((val: any) => {
              val.JobDisplayName = val.JobDisplayName + ' (' + "JCCo - " + val.JCCo + ')';
              if (this.lastUsedJCJMKeyID != null && val.JCJMKeyID == this.lastUsedJCJMKeyID) {
                this.formData.selectedJob = val;
              }
            });
            if (this.formData.selectedJob != null) {
              this.jobChanged();
            } else {
              this.phases = [{ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null }];
              this.formData.selectedPhase = this.phases[0];
            }
            return result;
          }
        })
      )
    );
  }

  private getPREHKeyIDByEmployee() {
    this.loading = true;
    this.employeeService.getPREHKeyIDByEmployee(this.formData.PRCo, this.formData.Employee, encodeURIComponent(this.formData.unlockPass) ?? null).then((response: any) => {
      this.employeeResults = response;
      this.employeeName = this.employeeResults != null ? this.employeeResults.FirstName + " " + this.employeeResults.LastName : null;
      this.employeeService.getClockHistory(this.formData.PRCo, this.formData.Employee, encodeURIComponent(this.formData.unlockPass) ?? null).then((historyResponse: any) => {
        this.lastFullClockIn = null;
        this.lastFullClockOut = null;
        this.lastClockIn = null;
        this.totalHours = null;
        if (historyResponse != null && historyResponse.length > 0) {
          if (!historyResponse[historyResponse.length - 1].ClockAction) { //not clocked in
            var reversedResponse = historyResponse.slice(-2).reverse();
            this.lastFullClockOut = reversedResponse[0];
            this.lastFullClockOut.ClockTimeDisplay = moment(this.lastFullClockOut.ClockTime).utc().format(this.dateFormat.toUpperCase() + this.timeFormat);
            this.lastFullClockIn = reversedResponse[1];
            this.lastFullClockIn.ClockTimeDisplay = moment(this.lastFullClockIn.ClockTime).utc().format(this.dateFormat.toUpperCase() + this.timeFormat);
            this.updateHoursColumnValue();
          } else {
            var reversedResponse = historyResponse.slice(-3).reverse();
            this.lastClockIn = reversedResponse[0];
            this.lastClockIn.ClockTimeDisplay = moment(this.lastClockIn.ClockTime).utc().format(this.dateFormat.toUpperCase() + this.timeFormat);
            this.lastFullClockOut = reversedResponse[1];
            this.lastFullClockOut.ClockTimeDisplay = moment(this.lastFullClockOut.ClockTime).utc().format(this.dateFormat.toUpperCase() + this.timeFormat);
            this.lastFullClockIn = reversedResponse[2];
            this.lastFullClockIn.ClockTimeDisplay = moment(this.lastFullClockIn.ClockTime).utc().format(this.dateFormat.toUpperCase() + this.timeFormat);
            this.updateHoursColumnValue();
          }
        }
      });
      this.loading = false;
    });
  }

  private updateHoursColumnValue() {
    var startTime = this.lastFullClockIn.ClockTime.substring(6, this.lastFullClockIn.ClockTime.length - 7);
    var stopTime = this.lastFullClockOut.ClockTime.substring(6, this.lastFullClockOut.ClockTime.length - 7);
    var elapsedHours = (stopTime - startTime) / (1000 * 60 * 60.0);
    this.totalHours = parseFloat(elapsedHours.toFixed(2));
  }

  private resetForm() {
    this.performingClockAction = false;
    this.formData.Employee = null;
    this.formData.Password = null;
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    this.clockStatus = null;
    this.clear();

    if (this.requirePasswordClockIO) {
      this.accountService.getAccountLogoutRedirect();
    }
  }

  private getLocation() {
    this.position = null;
    this.requestingLocation = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        setTimeout(() => {
          this.requestingLocation = false;
          this.geolocationEnabled = true;
          this.position = position;
        });
      });
    }
    else {
      this.requestingLocation = false;
    }
  }

  private getCompanies() {
    this.companies = [];
    this.accountService.getCompanies().then((response: any) => {
      if (response != null) {
        this.companies = response;
        if (this.companies.length > 0) {
          this.formData.PRCo = this.companies[0].PRCo;
        }
      }
    });
  }

  private getPhases() {
    this.phases = [];
    this.employeeService.getPhasesForClockIn(this.formData.selectedJob.JCJMKeyID, this.accessToken, false, encodeURIComponent(this.formData.unlockPass) ?? null).then((response: any) => {
      if (response != null) {
        var phases = response;
        phases.forEach((val: any) => {
          if (this.lastUsedJCJPKeyID != null && this.lastUsedJCJPKeyID == val.JCJPKeyID) {
            this.formData.selectedPhase = val;
          }
        });
        this.phases = phases;
      }
    });
  }

  private checkSigned() {
    this.signatureNEmpty = !this.signaturePad.isEmpty();
    this.redBorder = this.signaturePad.isEmpty();
  }

  private setClockStatusResponse(response: any) {
    this.clockStatus = response.ClockAction;
    this.lastUsedJCJMKeyID = response.LastUsedJCJMKeyID;
    this.lastUsedJCJPKeyID = response.LastUsedJCJPKeyID;
    if (this.clockInUsePhase) {
      this.formData.selectedJob = { JCJMKeyID: response.LastUsedJCJMKeyID, JobDisplayName: response.LastUsedJob };
      this.formData.selectedPhase = { JCJPKeyID: response.LastUsedJCJPKeyID, PhaseDescription: response.LastUsedPhase };
    }
    if (this.formData.selectedJob != null) {
      this.getPhases();
    }
    this.getPREHKeyIDByEmployee();
  }

  private showBanner(action: any) {
    var currentTime = moment();
    this.formData.labelFade = false;
    this.lastAction = true;
    this.formData.actionMode = action ? "success" : "danger";
    var clockText = action ? " clocked in at " : " clocked out at ";
    this.formData.action = "Employee " + this.formData.Employee + "- "
      + this.employeeName
      + clockText + currentTime.format("hh:mm A") + " successfully.";
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 5000);
    this.resetForm();
  }
}
